import { ProductPage } from "./Page.js"

export default ProductPage
